import { render, staticRenderFns } from "./modalLinkAttributeToCategory.vue?vue&type=template&id=5419bdde&"
import script from "./modalLinkAttributeToCategory.vue?vue&type=script&lang=js&"
export * from "./modalLinkAttributeToCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports